export const projectData = [
  {
    title: "GitDistributed",
    start_month: "08-2025",
    end_month: "12-2025",
    slug: "git-distributed",
    tags: ["c++", "tcp", "distributed systems"],
    link: "https://github.com/CornellDataScience/gitdistributed"
  },
  {
    title: "Paper Moderation in Collaboration with arXiv",
    start_month: "01-2025",
    end_month: "05-2025",
    slug: "paper-moderation-with-arXiv",
    tags: ["ml", "huggingface", "python"],
    link: ""
  },
  {
    title: "In-Memory Database (IMDb)",
    start_month: "08-2024",
    end_month: "12-2024",
    slug: "in-memory-database",
    tags: ["c++", "tcp", "systems programming"],
    link: "https://github.com/CornellDataScience/imdb"
  },
  {
    title: "Data Quality Research with Millennium Management",
    start_month: "08-2024",
    end_month: "05-2025",
    slug: "data-quality-with-millennium-management",
    tags: ["python", "pandas", "object-oriented programming"],
    link: "https://github.com/nchu05/millennium-data-quality"
  },
  {
    title: "CaddieAI",
    start_month: "03-2024",
    end_month: "05-2024",
    slug: "caddieai",
    tags: ["python", "docker", "flask", "aws ec2"]
  },
  {
    title: "Latte Link Mobile Application",
    start_month: "11-2023",
    end_month: "12-2023",
    slug: "latte-link",
    tags: ["android studio", "kotlin"],
    link: "https://github.com/nchu05/Latte-Link"
  }
];
